"use client";

import PropTypes from "prop-types";
import Body from "@/components/Body";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const Faq = ({ items, ...props }) => (
  <Accordion
    type="single"
    collapsible
    itemScope
    itemType="https://schema.org/FAQPage"
    {...props}
  >
    {items.map(({ _key, answer, question }) => (
      <AccordionItem
        key={`faq-item-${_key}`}
        value={_key}
        itemScope
        itemProp="mainEntity"
        itemType="https://schema.org/Question"
      >
        <AccordionTrigger as="h2" itemProp="name">
          {question}
        </AccordionTrigger>
        <AccordionContent
          pb={4}
          itemScope
          itemProp="acceptedAnswer"
          itemType="https://schema.org/Answer"
        >
          <div itemProp="text">
            <Body value={answer} />
          </div>
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

Faq.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      _key: PropTypes.string.isRequired,
      answer: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.string,
      ]).isRequired,
      question: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default Faq;
